import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { techDeploy } from '@/mocks/launch';

export default function TechDeploy() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="技术部署"
            title="华辉数智承担 0# 核心技术交付"
            subtitle="TOMA 智能体、数字货架、车载卡激活系统与数据看板，构成 0# 场景的技术底座。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {techDeploy.map((item, i) => (
            <Reveal key={item.title} delay={i * 80}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors">
                <div className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className={`${item.icon} text-accent-700 text-2xl`}></i>
                </div>
                <h3 className="mt-4 font-heading font-bold text-base text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}